import React from "react";

const ClientApp = ({
  style = {},
  width = 22,
  height = 22,
  className = "",
  color = "#fff",
  viewBox = "0 0 22 22",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      className={className}
      style={style}
      {...rest}>
      <path
        d="M19.56,0H2.44A2.45,2.45,0,0,0,0,2.44V19.56A2.45,2.45,0,0,0,2.44,22H19.56A2.45,2.45,0,0,0,22,19.56V2.44A2.45,2.45,0,0,0,19.56,0ZM7.33,17.11H4.89V8.56H7.33Zm4.89,0H9.78V4.89h2.44Zm4.89,0H14.67V12.22h2.44Z"
        fill={color}
      />
    </svg>
  );
};

export default ClientApp;
